const TWITTER_HOST = /^(https?:\/\/)(?:www\.|mobile\.)?twitter\.com\//i

/**
 * Legacy Twitter permalinks (`http(s)://twitter.com/<handle>/statuses/<id>`) force the
 * reader through an X login wall, while the equivalent `https://x.com/<handle>/status/<id>`
 * link opens without logging in.
 *
 * This is a display-only rewrite: host `twitter.com -> x.com` (incl. `www.`/`mobile.`)
 * and path segment `/statuses/ -> /status/`. Any non-twitter.com URL (and
 * undefined/empty) is returned unchanged. (NI-2659)
 */
const toXDotComUrl = (url?: string): string | undefined => {
  if (!url || !TWITTER_HOST.test(url)) {
    return url
  }

  return url.replace(TWITTER_HOST, '$1x.com/').replace(/\/statuses\//i, '/status/')
}

export default toXDotComUrl
